<template>
  <section class="quote-section quote-summary">
    <h3>Summary</h3>
    <div class="summary-fields">
      <ValueDisplayBox text="Subtotal" :value="formattedSubtotal" background="var(--summary-subtotal-bg)" />
      <ValueDisplayBox text="Total Weight" :value="formattedTotalWeight" background="var(--summary-subtotal-bg)" />
      <div class="primary-input discount-input">
        <QuoteLineNumberInput v-model="quote.DISCOUNTPCT" />
        <label>Discount %</label>
      </div>
      <ValueDisplayBox text="Order Total" :value="formattedTotal" background="var(--summary-total-bg)" />
    </div>
  </section>
</template>

<script>
import ValueDisplayBox from '@/components/inputs/ValueDisplayBox.vue';
import QuoteLineNumberInput from '@/components/quotes/QuoteLineNumberInput.vue';
import useQuoteProductsQuery from '@/composables/useQuoteProductsQuery';
import {
  calculateQuoteSubtotal,
  calculateQuoteTotal,
  calculateQuoteTotalWeight,
  formatCurrency,
} from '@/composables/useQuoteLinePricing';

export default {
  name: 'QuoteSummary',
  components: {
    ValueDisplayBox,
    QuoteLineNumberInput,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  setup() {
    useQuoteProductsQuery.useQuoteProductsQuery();

    return {
      quoteProducts: useQuoteProductsQuery.quoteProducts,
    };
  },
  computed: {
    subtotal() {
      return calculateQuoteSubtotal(this.quote);
    },
    total() {
      return calculateQuoteTotal(this.quote);
    },
    totalWeight() {
      return calculateQuoteTotalWeight(this.quote, this.quoteProducts);
    },
    formattedSubtotal() {
      return formatCurrency(this.subtotal);
    },
    formattedTotalWeight() {
      return `${formatCurrency(this.totalWeight)} lbs`;
    },
    formattedTotal() {
      return formatCurrency(this.total);
    },
  },
};
</script>

<style lang="scss" scoped>
.quote-summary {
  --summary-subtotal-bg: #{$appBackgroundColor};
  --summary-total-bg: #{$orderTotalBackgroundColor08};

  h3 {
    margin: 0 0 1.5rem;
    color: $textColor87;
  }
}

.summary-fields {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 1rem;
  width: 100%;
}

.summary-fields > * {
  flex: 1 1 0;
  min-width: 0;
}

.discount-input {
  width: 100%;
}
</style>
